import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
  providedIn: 'root'
})
export class RackDataService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) {
  }

  public getEmptyModel() {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Rack/GetEmptyModel`;
    return this.httpClient.get(url);
  }
  public getList(start, count, sortBy, sortDirection, filters) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Rack/GetList?start=${start}&length=${count}&sortBy=${sortBy}&sortDirection=${sortDirection}&filters=${JSON.stringify(filters)}`;
    return this.httpClient.get(url);
  }

  public getById(id) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Rack/Rack?id=${id}`;
    return this.httpClient.get(url);
  }

  public getBySerialNumber(serial) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Rack/RackBySerial?serial=${serial}`;
    return this.httpClient.get(url);
  }

  public saveRack(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Rack/Save`;
    return this.httpClient.post(url, dto);
  }

  public saveRequisitionLocation(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Rack/SaveRequisitionLocation`;
    return this.httpClient.post(url, dto);
  }

  public getRackTypes() {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Rack/GetRackTypeList`;
    return this.httpClient.get(url);
  }

  public getGetCurrentRackForRequisition(id) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Rack/GetCurrentRackForRequisition?id=${id}`;
    return this.httpClient.get(url);
  }
}
